var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770.87 500.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Foreground_Layer",
    "data-name": "Foreground Layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.7,252h56.17v58.8h36v40.91h-36V455.87q0,11.58,4.47,16.6t17.11,5A90.29,90.29,0,0,0,333,476.13v42.26a116.65,116.65,0,0,1-34,5q-59.08,0-60.25-59.24Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.41,443.53,569,310.58h54.23L569.59,519.36h-47L482.71,388l-39.85,131.4H396L342.37,310.58H396.6L424,443.34l38.49-132.76h40.63Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.93,459.36H639.56V310.58h56.37Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.77,726.92Q468,752,431.23,752q-33.81,0-51.6-19.3t-18.18-56.53V539.36h56.18v135q0,32.64,29.93,32.64,28.57,0,39.26-19.7v-148h56.37V748.14H490.32Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.56,748.14H563.19V539.36h56.37Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.93,748.14H639.56V479.36h56.37Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.72,326.21Q864.4,306.73,831,306.72q-37.9,0-60.45,28l-1.75-24.12H715.89V519.36h56.18V372.14q11.85-20.07,35.57-20.07,18.08,0,25.85,8t7.77,25.76v50h0V558.4q-20-22.77-50.73-22.77-38.29,0-60.36,28.94t-22.06,77.77q0,51.7,22.45,80.75t59.58,29q33,0,54-26l2.72,22.19h50.56V384.48Q897.05,345.71,880.72,326.21ZM841.24,685.33q-10.69,21.84-36.74,21.84-19.63,0-29.93-15.65t-10.3-45q0-65.52,40.62-65.51,25.85,0,36.35,21.83Z",
    transform: "translate(-126.56 -251.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.17,563.58Q308.3,535.5,269.82,535.5q-31.69,0-51.12,22.58V310.58H126.56v42.64h36V748.14h50.54L215.59,726Q236,752,270.21,752q38.67,0,60.25-28.08T352,645.68v-3.09Q352,591.65,330.17,563.58ZM291.78,680.41Q283.23,707,256,707q-27,0-37.32-22V602.65q10.1-21.79,36.93-21.8,20,0,30.13,14.57t10.1,46.21Q295.86,667.67,291.78,680.41Z",
    transform: "translate(-126.56 -251.97)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.c6a1efe6bc87d6eb1bab58312ae02de2.svg";
export { ForwardRef as ReactComponent };